import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { getOneGalleryData } from "../../store/gallery/OneGallery/reducer";
import AdminNavbar from "../../components/partial/AdminNavbar";

const ShowImages = () => {
  const location = useLocation();
  const id = location?.state.id;
  const { title } = useParams();
  const dispatch = useDispatch();
  const OneGalleryData = useSelector(
    (state) => state.OneGalleryReducer.OneGalleryData,
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  useEffect(() => {
    dispatch(getOneGalleryData(id)); // Ensure you're passing the correct ID
  }, [dispatch, id]);
  //nvm-admin/gallery/:title
  const handleImageClick = (image) => {
    setCurrentImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentImage("");
  };

  console.log("OneGalleryData:", OneGalleryData);

  // Handle loading or undefined data (show loading only while no data)
  if (OneGalleryData == null) {
    return <div>Loading gallery data...</div>;
  }

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Admin Navbar */}
      <div className="lg:w-1/4 h-full bg-gray-100">
        <AdminNavbar />
      </div>

      {/* Main Content */}
      <div className="w-full h-full overflow-auto p-6">
        <div className="h-64 w-full bg-gray-200 flex items-center justify-center rounded-lg shadow-xl mb-8">
          <span className="text-3xl font-semibold text-gray-700">
            {OneGalleryData.title}
          </span>
        </div>

        <div className="flex flex-wrap justify-center gap-6 w-full mx-auto p-6 ">
          {OneGalleryData.photos?.map((photo, index) => (
            <div
              key={index}
              onClick={() => handleImageClick(`${photo}`)} // Open modal on click
              className="bg-white rounded-lg shadow-lg w-full sm:w-[45%] lg:w-[30%] cursor-pointer transition-transform transform hover:scale-105 hover:shadow-2xl"
            >
              <img
                className="w-full h-48 object-cover rounded-lg"
                src={`${photo}`}
                alt={`${title}`}
              />
            </div>
          ))}
        </div>

        {/* Modal */}
        <Modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          className="fixed inset-0 flex items-center justify-center z-50"
          overlayClassName="fixed inset-0 bg-black bg-opacity-60 transition-opacity duration-300"
          ariaHideApp={false}
        >
          <div className="relative rounded-lg shadow-2xl max-w-3xl w-full p-4 animate-fadeIn">
            {/* Close Button */}
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 bg-slate-50 opacity-50 font-semibold hover:scale-125 duration-300 text-gray-800 rounded-md px-1"
            >
              ✕
            </button>
            {/* Image */}
            <img
              src={currentImage}
              alt="Carousel"
              className="w-full h-auto object-contain rounded-md"
            />
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default ShowImages;
